import {extend, override } from 'flarum/extend';
import IndexPage from 'flarum/components/IndexPage';
import ItemList from 'flarum/utils/ItemList';
import TagsPage from 'flarum/tags/components/TagsPage';
import TagsDiscussionModal from 'flarum/tags/components/TagDiscussionModal';
import SettingsPage from 'flarum/components/SettingsPage'
import sortTags from 'flarum/tags/utils/sortTags';
import Link from 'flarum/components/Link';
import classList from 'flarum/utils/classList';
import PreferredTagsModal from '../components/PreferredTagsModal';
import FieldSet from 'flarum/components/FieldSet';
import Button from 'flarum/components/Button';
import TagsListSeparator from '../components/TagsListSeparator';

export default () => {
    extend(TagsPage.prototype, 'oninit', function() {
        this.tags = sortTags(app.store.all('tags')).filter(tag => {
            return !tag.isChild() && tag.position() !== null &&
                (tag.isForcedPreferred() || tag.isPreferred() !== false);
        });
        this.filtered = true;
    })

    extend(TagsPage.prototype, 'view', function() {
        if (this.tags.length > 0 && !this.filtered) {
            this.tags = sortTags(app.store.all('tags')).filter(tag => {
                return !tag.isChild() && tag.position() !== null &&
                    (tag.isForcedPreferred() || tag.isPreferred() !== false);
            });
            m.redraw();
            this.filtered = true;
        }
        else {
            this.filtered = false;
        }
    })

    /*
    TODO: Remove the code above and use the code below,
          when https://github.com/flarum/tags/pull/138
          is merged and released.
    *//*
    override(TagsPage.prototype, 'items', function() {
        return sortTags(app.store.all('tags')).filter(tag => {
            return !tag.isChild() && tag.position() !== null &&
                (tag.isForcedPreferred() || tag.isPreferred() !== false);
        });
    })
    */

    override(IndexPage.prototype, 'navItems', function (original) {
        const items = original();
        const filteredItems = Object.keys(items.items).filter((key) => {
            if(/tag\d+$/g.test(key)) {
                let tagItem = items.items[key].content.attrs.model;

                if (tagItem.isChild()) {
                    // Tag is a child tag, get parent
                    tagItem = tagItem.parent()
                }
                
                return (tagItem.isForcedPreferred()
                    || tagItem.isPreferred() !== false)
                    && tagItem.position() !== null;
            }
            else {
                // special case to filter out "more tags..."
                // will show if more than 3 secondary tags exist
                if(key.indexOf('moreTags') > -1) {
                    return false;
                }

                // this is not a tag or the more link so we dont care if it is preferred
                return true;
            }
        }).reduce((obj, key) => {
            obj[key] = items.items[key];
            return obj;
        }, {});

        // make new itemlist based on our filtered items
        const mutatedItems = new ItemList();
        Object.keys(filteredItems).forEach(k => {
            mutatedItems.add(k, filteredItems[k].content);
        });

        // add foretrukne rum button
        mutatedItems.add('separator', <TagsListSeparator></TagsListSeparator>, -16);
        mutatedItems.add('foretrukne-rum', <Link
            href="/"
            className={classList(['TagLinkButton', 'hasIcon'])}
            onclick={
                () => {
                    setTimeout(() => app.modal.show(PreferredTagsModal), 500);
                }
            }><i class="Button-icon icon Tagicon fas fa-edit"></i> {app.translator.trans('preferred-tags.forum.edit-foretrukne-rum')}</Link>, -18);
        
        return mutatedItems;
    });

    extend(SettingsPage.prototype, 'settingsItems', function(items) {
        const settingsItems = new ItemList();
        
        settingsItems.add('foretrukneRumDescription',
            <p>{app.translator.trans('preferred-tags.forum.settings.foretrukne-rum-description')}</p>, 10);
        
        settingsItems.add('foretrukneRumButton',
            <Button className="Button Button--primary" onclick={() => app.modal.show(PreferredTagsModal) }>
                {app.translator.trans('preferred-tags.forum.settings.show-foretrukne-rum')}
            </Button>, 5);

        items.add('foretrukneRum',
            <FieldSet label={app.translator.trans('preferred-tags.forum.foretrukne-rum')}>
                { settingsItems.toArray() }
            </FieldSet>
        , 50);
    });

    extend(TagsDiscussionModal.prototype, 'content', function() {
        this.tags = this.tags?.filter(tag => {
            if (tag.isChild()) {
                return (tag.parent().isForcedPreferred()
                    || tag.parent().isPreferred() !== false)
                    && tag.position() !== null;
            }
            else {
                return (tag.isForcedPreferred()
                    || tag.isPreferred() !== false)
                    && tag.position() !== null;
            }
        })
    });
}
